import { useEffect, useRef } from 'react';
import { prefillVmLevelFields } from '../components/VMBasedMigrationsConfig/helpers';

export const useApplianceRedeployPrefill = ({
    isRedeploy,
    cloudAccount,
    projects,
    form,
    setInstanceTags,
    loadProjectRegions,
    loadRegionNetworks,
    prefillCommonFromAppliance,
}) => {
    const hasPrefilledRef = useRef(false);

    useEffect(() => {
        if (hasPrefilledRef.current) {
            return;
        }
        if (!isRedeploy || !cloudAccount?.appliance || projects.length === 0) {
            return;
        }
        hasPrefilledRef.current = true;

        const appliance = cloudAccount.appliance;
        const props = appliance.cloud_properties;

        form.setFieldsValue({
            machineType: props.instance_type || 'e2-medium',
            diskType: props.disks_types?.[0] || 'pd-standard',
            vmName: props.vapp_name,
        });

        if (props.tags && typeof props.tags === 'object') {
            setInstanceTags(props.tags);
        }

        prefillCommonFromAppliance(appliance);

        if (appliance.vm_level_migration_enabled) {
            prefillVmLevelFields(appliance, form);
        }

        if (props.network) {
            const eth0 = props.network.interfaces?.eth0 || {};
            form.setFieldsValue({
                networkName: eth0.network_name,
                subnet: eth0.internal_subnet_id,
                assignPublicIp: eth0.assign_public_ip ? 'automatic' : 'none',
                networkTier: eth0.network_tier || 'STANDARD',
            });
        }

        if (props.project_id) {
            loadRedeployData({ appliance, projects, form, loadProjectRegions, loadRegionNetworks });
        }
    }, [isRedeploy, cloudAccount, projects]);
};

const loadRedeployData = async ({ appliance, projects, form, loadProjectRegions, loadRegionNetworks }) => {
    const props = appliance.cloud_properties;
    const project = projects.find(
        (proj) => proj.identifier === props.project_id || proj.name === props.project_id,
    );
    if (!project) {
        return;
    }

    const projectValue = project.identifier || project.name;
    form.setFieldsValue({ project: projectValue });
    const projectData = await loadProjectRegions(projectValue);

    if (!props.region) {
        return;
    }
    form.setFieldsValue({ region: props.region });

    const regionFromList = projectData?.regions?.find((region) => region.name === props.region);
    await loadRegionNetworks(projectValue, props.region, regionFromList);

    if (props.az) {
        form.setFieldsValue({ zone: props.az });
    }
};
